"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ManipulationTypes_1 = require("./ManipulationTypes");
const withManipulation = (prefix, reducer) => (state, action) => {
    switch (action.type) {
        case `${prefix}_${ManipulationTypes_1.PAGINATION_CHANGE}`:
            return Object.assign(Object.assign({}, state), { man: Object.assign(Object.assign({}, state.man), { pagination: action.payload }) });
        case `${prefix}_${ManipulationTypes_1.FILTER_CHANGE}`:
            return Object.assign(Object.assign({}, state), { man: Object.assign(Object.assign({}, state.man), { filter: action.payload }) });
        case `${prefix}_${ManipulationTypes_1.SORT_CHANGE}`:
            return Object.assign(Object.assign({}, state), { man: Object.assign(Object.assign({}, state.man), { sort: action.payload }) });
        case `${prefix}_${ManipulationTypes_1.SEARCH_CHANGE}`:
            return Object.assign(Object.assign({}, state), { man: Object.assign(Object.assign({}, state.man), { search: action.payload }) });
        default:
            return reducer(state, action);
    }
};
exports.default = withManipulation;
//# sourceMappingURL=ManipulationReducers.js.map